import AppDropDown from "@toothfairy/shared-ui/AppDropDown";
import AppStateManager from "@toothfairy/shared-ui/AppStateManager";
import AppToast from "@toothfairy/shared-ui/AppToast";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import AppTextInput from "@toothfairy/shared-ui/AppTextInput";
import AppUser from "@toothfairy/shared-ui/AppUser";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Platform, View } from "react-native";
import ToothFairyButton from "../../../Components/ToothFairyComponents/ToothFairyButton";
import Constants from "../../../Constants";
import { isLargeScreen } from "../../MainViewContainer";

const UserPreferencesNLP = ({
  handleUserUpdate,
  showReplyLanguage = true,
  languagesData,
}) => {
  const { t } = useTranslation();
  const { currentTheme } = AppTheme.useTheme();
  const AppToasty = AppToast.useToast();
  const { user } = AppUser.useUser();
  const { state } = AppStateManager.useAppStateManager();
  const [instructions, setInstructions] = useState(
    user?.userInstructions || "",
  );

  const handleSaveInstructions = () => {
    if (instructions?.length > 512) {
      return AppToasty.show(t("profile.instructionsMaxLength"), {
        type: "danger",
      });
    }
    handleUserUpdate("userInstructions", instructions);
  };

  return (
    <View
      style={{
        width: Platform.OS === "web" && isLargeScreen() ? 450 : 250,
        marginTop: 20,
        alignSelf: "center",
      }}
    >
      <View
        style={{
          marginHorizontal: 10,
        }}
      >
        {!showReplyLanguage && state?.languagesConfig?.length > 0 && (
          <AppDropDown
            showTextInputLabel
            label={t("profile.outputLanguage")}
            inputLabelStyle={{
              marginLeft: 0,
            }}
            dropDownStyle={{
              minWidth: 100,
              borderColor: currentTheme?.theme?.border_color,
              maxWidth: !isLargeScreen() && 250,
            }}
            isElevated={false}
            dropdownIconColor="transparent"
            items={[
              { id: "def", name: t("profile.defaultToInputLanguage") },
              ...state?.languagesConfig,
            ]}
            propertyLabel="name"
            propertyValue="id"
            selectedValue={user.replyLanguage}
            onValueChange={(itemValue, itemIndex) => {
              handleUserUpdate("replyLanguage", itemValue);
            }}
          />
        )}
      </View>
      <AppTextInput
        showTextInputLabel
        label={t("profile.personalInstructions")}
        placeholder={t("profile.personalInstructionsPlaceholder")}
        value={instructions}
        onChangeText={setInstructions}
        multiline={true}
        maxCharacters={4096}
        // wrapperInputStyle={{ height: 300 }}
        textContainer={{
          minHeight: 400,
          padding: 10,
          marginTop: 10,
        }}
      />
      <ToothFairyButton
        title={t("common.save")}
        onPress={handleSaveInstructions}
        wrapperStyle={{
          marginTop: 15,
          minWidth: 120,
          height: Constants.appButtonHeight,
          alignSelf: "center",
        }}
      />
    </View>
  );
};

export default UserPreferencesNLP;
